import { atom } from "jotai";
import Cookies from "js-cookie";
import type { JwtPayload } from "jwt-decode";

import { config } from "~/data";

import { getAccountState, maskValue } from "./helpers";

export interface ScmpPianoJWT extends JwtPayload {
  email: string;
  first_name: string;
  last_name: string;
}
export const accountAtom = atom(getAccountState());

export const registerEmailCookieAtom = (() => {
  const key = "register_email";
  const domain = config.account.cookieDomain;
  const value = atom(Cookies.get(key) ?? null);
  const wrapped = atom(
    get => get(value),
    (_get, set, newValue?: string | null) => {
      if (newValue) {
        const masked = maskValue(newValue);
        Cookies.set(key, masked, { domain, expires: 3 });
        set(value, masked);
      } else {
        Cookies.remove(key, { domain });
        set(value, null);
      }
    },
  );
  return wrapped;
})();
